import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

interface Props {
  title: React.ReactNode
}

export const InfoTooltip: React.FC<Props> = ({title}) => {
  return (
    <Tooltip title={title} placement="top" arrow>
      <span
        tabIndex={0}
        role="button"
        aria-label="Explain column"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          verticalAlign: 'super',
          marginLeft: 4,
          cursor: 'help',
          lineHeight: 0,
          // Make sure the icon is easy to hit
          padding: '0 2px',
        }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <InfoOutlinedIcon
          // Bigger than before, but still compact
          sx={{fontSize: '1rem', opacity: 0.8}}
        />
      </span>
    </Tooltip>
  )
}
